/**
 * 注意：当前注释说明供学习框架使用，实际开发建议删除
 * utils/request对axios进行了封装，在当前模块进行引入使用
 * 当前页面提供了get/post/delete三种请求方式的示例供参考
 */

import request from '@/utils/request'
import users from './mock/users.json'
import roles from './mock/roles.json'
export default {

  async login (params) {
    // let obj = {
    //   'code': 200,
    //   'message': 'success',
    //   'data': {
    //     'id': '1eb217bf-f1bd-49bd-b893-4ca594ddbc22',
    //     'account': 'admin',
    //     'time': 1712583228180,
    //     'authList': '["01-1","02-1","03-1","04-1","05-1","06-1","07-1","08-1","09-1","10-1","11-1","12-1","13-1", "14-1", "15-1", "16-1", "17-1", "18-1", "19-1", "20-1", "21-1"]',
    //     'token': 'MCP8Zo+E6ONVlOy2KaR7lM/shZlZyu35jILQHwRYErAhBXH6RU6blrEhuhbWpOMo5zMdyCAnkfq/3bhWYaBxFNJDcd0CArXBGkYtJr7GweXfBIB5ImW7+koJIqMv8NoNzBLfqeRGR4SSrzr6c2Tfg9xaGktU/0kE/lAFQlaPXdCOShrSJB+82JBW8AYEl5EM3qov8BolM0aNJck2PK+2/V/LYElpsGehISp/DFjD/YQkWDalycZdO8kVA/nUtX4iKSRmf9JTLDfZpdXvCpOC9sU7R1AJsz1pEl2Gd99mzrhbXzANoZ2xlZQWEsIdZJvFf90nAZjFgIAGffhaQLbE8Q=='
    //   }
    // }
    // if (process.env.NODE_ENV !== 'production') return obj
    let res = await request.post('/users/login', params)
    return res
  },

  async logout () {
    return request.get('/users/logout')
  },
  // 获取用户列表
  async getUsers (params) {
    if (process.env.NODE_ENV !== 'production') return users
    let res = await request.get('/users/select', {
      params
    })
    return res.data
  },
  // 添加用户
  async addUser (params) {
    let res = await request.post('/users/add', params)
    return res.data
  },
  // 删除用户
  async deleteUser (params) {
    let res = await request.get('/users/deleteById', { params })
    return res.data
  },
  // 更新
  async updateUser (params) {
    let res = await request.post('/users/update', params)
    return res.data
  },
  async getRoles (params) {
    if (process.env.NODE_ENV !== 'production') return roles
    let res = await request.get('/roles/select', {
      params
    })
    return res.data
  },
  async addRole (params) {
    let res = await request.post('/roles/add', params)
    return res.data
  },
  // 删除角色
  async deleteRole (params) {
    let res = await request.get('/roles/deleteById', { params })
    return res.data
  },
  // 更新
  async updateRole (params) {
    let res = await request.post('/roles/update', params)
    return res.data
  },
  // 获取图书馆列表
  async getLibraries (params) {
      // if (process.env.NODE_ENV !== 'production') return users
      let res = await request.get('/libraries/select', {
        params
      })
      return res.data
  }
}
